import { render, staticRenderFns } from "./ManagePtm.vue?vue&type=template&id=259b813c&scoped=true&"
import script from "./ManagePtm.vue?vue&type=script&lang=js&"
export * from "./ManagePtm.vue?vue&type=script&lang=js&"
import style0 from "./ManagePtm.vue?vue&type=style&index=0&id=259b813c&lang=scss&scoped=true&"
import style1 from "./ManagePtm.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ManagePtm.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259b813c",
  null
  
)

export default component.exports